
import { Vue, Options } from 'vue-class-component';

@Options({
    props: {
        text: String
    }
})
export default class LoadingScreen extends Vue {
    text = "Saving, please wait";
}
